import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { VmafError } from '../../api/ErrorNormalizer';
import { ISiteIds } from './types';

const requestSiteCreate = createAsyncAction(
  'SITE_META/CREATE/REQUEST',
  'SITE_META/CREATE/SUCCESS',
  'SITE_META/CREATE/FAILURE',
)<void, ISiteIds, VmafError>();

const requestSiteBuild = createAsyncAction(
  'SITE_META/BUILD/REQUEST',
  'SITE_META/BUILD/SUCCESS',
  'SITE_META/BUILD/FAILURE',
)<void, void, VmafError>();

const setSiteIsReady = createStandardAction('SITE_META/SET_SITE_READY')();

const setMediaUploaded = createStandardAction('SITE_META/SET_MEDIA_UPLOADED')<
  ISiteIds['metaSiteId']
>();

export {
  requestSiteCreate,
  requestSiteBuild,
  setMediaUploaded,
  setSiteIsReady,
};
